import { AIMatchKey, AIMatchSettingsType, Setting } from 'components/types';
import dayjs from 'dayjs';

export const getTimeSlotOptions = (
  startTime?: Date | string,
  endTime?: Date | string
) => {
  const start = dayjs(
    startTime || dayjs().set('hour', 7).set('minutes', 30),
    'HH:mm'
  );
  const end = dayjs(endTime || start.add(24, 'hours'), 'HH:mm');
  const diff = end.diff(start, 'hours');

  let currentTime = start.clone();

  return Array.from({ length: diff * 2 }, () => {
    currentTime = currentTime.add(30, 'minutes');
    const value = currentTime.format('HH:mm');

    return {
      value,
      label: value
    };
  });
};

export const getValuesByAIMatchSettingsType = (
  type: AIMatchSettingsType,
  settings: Setting[]
) => {
  return settings.find((setting) => setting.key === `${AIMatchKey}.${type}`);
};

export const convertMinutesToDecimalHours = (minutes: number) =>
  minutes % 60
    ? `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`
    : `${minutes / 60}`;

export function minutesToHHmm(totalMinutes: number): string {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const hh = hours.toString().padStart(2, '0');
  const mm = minutes.toString().padStart(2, '0');
  return `${hh}:${mm}`;
}

export function hhmmToMinutes(hhmm: string): number {
  if (!hhmm) return 0;
  const [h, m] = hhmm.split(':');
  return parseInt(h, 10) * 60 + parseInt(m, 10);
}
